import * as React from 'react'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'

import Header from '../components/Header'
import Footer from '../components/Footer'

import Home from '../scenes/Home'
import Login from '../scenes/Auth/Login'
import Register from '../scenes/Auth/Register'
import Article from '../scenes/Article'
import ArticleDetail from '../scenes/ArticleDetail'
import Author from '../scenes/Analyst'
import Search from '../scenes/Search'

class MainLayout extends React.Component<any, any> {
    render() {
        return (
            <div className="app">
                <Header />
                <Switch>
                    <Route exact={true} path="/" component={Home} />
                    <Route exact={true} path="/login" component={Login} />
                    <Route exact={true} path="/register" component={Register} />
                    <Route exact={true} path="/author/:authorId" component={Author} />
                    <Route exact={true} path="/search/:input" component={Search} />
                    <PrivateRoute token={this.props.token} exact={true} path="/article" component={Article} />
                    <PrivateRoute token={this.props.token} exact={true}  path="/article/:id" component={ArticleDetail} />
                </Switch>
                <Footer />
            </div>
        )
    }
}

const PrivateRoute = ({component: Component, token, ...rest}: any) => {
    return (
    <Route
        {...rest}
        render={(props) => (token && token.length > 0)
        ? <Component {...props} />
        : <Component {...props} />}
    />
    )
}

const mapStateToProps = (state: any) => {
    return {
        token: state.fetchedToken,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
    }
}

export default connect<{}, {}, any>(mapStateToProps, mapDispatchToProps)(MainLayout)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/routes/MainLayout.tsx